export enum PaymentRequestStatusEnum {
  CONFIRMED = <any>'confirmed',
  APPROVED = <any>'approved',
  REJECTED = <any>'rejected',
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/payment-request-status.enum.ts